import { render, staticRenderFns } from "./AddOrUpdateLabCategoryModal.vue?vue&type=template&id=f8c733da&"
import script from "./AddOrUpdateLabCategoryModal.vue?vue&type=script&lang=js&"
export * from "./AddOrUpdateLabCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./AddOrUpdateLabCategoryModal.vue?vue&type=style&index=0&id=f8c733da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports